module.exports = __webpack_public_path__ + "img/Speaker.2b2e2ff3.png";